import { Component } from '@angular/core';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { Location } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { Currency } from 'src/app/assabil-kernel/models/entities/control-tables/currency';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { CurrencyRequest } from 'src/app/assabil-kernel/models/dtos/control-tables/currency-request';



@Component({
  selector: 'currency-list',
  templateUrl: './currency-list.component.html',
  styleUrls: ['./currency-list.component.scss']
})
export class CurrencyListComponent extends BasePage2<Currency> {

  // Filter fields
  // ---------------------------------------------------
  code: string;
  name: string;
  rate : number;
  lastUpdate : Date;
  // ---------------------------------------------------
      
  // ---------------------------------------------------
  currencies: Currency[] = [];
  // ---------------------------------------------------
  
  // ---------------------------------------------------

  constructor(
      protected toastr            : ToastrService,
      protected router            : Router,
      protected baseService       : BaseService,
      protected leanUtilsService  : LeanUtilsService,
      protected controlService        : ControlTablesService,
      protected location          : Location) {
      super(toastr, router, baseService, leanUtilsService, location);

      this.entityName = "currency";
  }
  // ---------------------------------------------------



  // ---------------------------------------------------
  listFields = [
      { prop: 'currencyCode', name: 'Code',  insertOnly : true},
      { prop: 'name', name: 'Name' },
      { prop: 'rank', name: 'Rang' },
      { prop: 'theRate', name: 'Taux'},
      { prop: 'lastUpdate', name: 'Derniere MAJ' }
  ]

  

//----------------------------------------------------------------------
getRows(): Currency[] {
      return this.currencies;
  }
//----------------------------------------------------------------------

//----------------------------------------------------------------------
new(){
  let entity :  Currency= new Currency();
  entity.inserted = true;
  entity.edit = true;
  this.currencies.push(entity);
  this.currencies = [...this.currencies];
}
//----------------------------------------------------------------------


//----------------------------------------------------------------------
saveRow(currency : Currency): Promise<Currency> {
  let request  : CurrencyRequest = new CurrencyRequest(this.controlService.getUserInfo());
  request.currency = currency;
  return this.controlService.save(this.entityName, request);
}
//----------------------------------------------------------------------


//----------------------------------------------------------------------
loadData() {
  let request         : BaseRequest = this.controlService.getRequest();
  request.strArg1 = this.code;
  request.strArg2 = this.name;

  this.controlService.getList(this.entityName, request).then(result => {
      this.currencies = result;
  })
}
//----------------------------------------------------------------------

}
